<!-- @format -->

<ng-container *transloco="let t">
  <app-widget-container [title]="t('FRONTPAGE.GRADE_AVERAGE.TITLE')" [subtitle]="t('FRONTPAGE.GRADE_AVERAGE.SUBTITLE')">
    <app-select-plan-dropdown
      [widget]="'app-grade-average'"
      (selectionChange)="onDropdownSelectionChange($event)"></app-select-plan-dropdown>

    @if (studyProgressGraphResults$ | async; as studyProgressGraphResults) {
      @if (studyProgressGraphResults) {
        <div class="col-12 sis-mt-xl sis-mb-lg grade-container">
          <p class="sis-mb-zero">{{ t("FRONTPAGE.GRADE_AVERAGE.TITLE") }}</p>
          @if (studyProgressGraphResults.average) {
            <p class="big-font sis-mt-sm sis-mb-sm" data-cy="grade-average">
              {{ studyProgressGraphResults.average | decimalNumber }}
            </p>
          }
          @if (!studyProgressGraphResults.average) {
            <p class="big-font sis-mt-sm sis-mb-sm">-</p>
          }
        </div>
      }
      @if (!studyProgressGraphResults) {
        <div class="sis-mt-md">
          <p>{{ t("FRONTPAGE.GRADE_AVERAGE.FETCHING_PLANS_FAILED") }}</p>
        </div>
      }
    }

    @if (loading()) {
      <div aria-busy="true" class="d-flex justify-content-center pt-3">
        <sis-small-spinner />
      </div>
    }
  </app-widget-container>
</ng-container>
